import { render } from "./ProposalArgumentPlayerControls.vue?vue&type=template&id=7ff224b6"
import script from "./ProposalArgumentPlayerControls.vue?vue&type=script&lang=js"
export * from "./ProposalArgumentPlayerControls.vue?vue&type=script&lang=js"

import "./ProposalArgumentPlayerControls.vue?vue&type=style&index=0&id=7ff224b6&lang=scss"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__